<template>
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>

            <v-toolbar fixed dark color="secondary">
                <v-btn icon dark @click="dialog = false">
                    <v-icon>close</v-icon>
                </v-btn>
                <v-toolbar-title>Documentos</v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>

            <v-container class="mt-4">
                <v-layout wrap mt-4>
                    <v-flex xs12>
                        <v-card-text v-if="canModify">
                            <file-picker
                                    :loading="uploading"
                                    :docs="docs"
                                    @select="upload"
                                    @error:unsupported="onUnsupportedFile"
                                    @error:max-size="onMaxFileSize"/>
                        </v-card-text>

                        <v-card-text v-if="docs.length === 0" class="text-xs-center">Aun no se han subido documentos</v-card-text>

                        <v-card-text v-else>
                            <v-layout wrap>
                                <v-flex xs12 sm6 md3 xl2 px-2 py-3 v-for="doc in localDocs" :key="doc.id">
                                    <v-card @click="openDoc(doc.path)" hover class="pa-2" color="kim-card" style="overflow: visible">
                                        <v-btn @click.stop="deleteFile(doc)" v-if="doc.user.id === currentUser.id && canModify" small absolute top right fab color="error">
                                            <v-icon>fa-trash</v-icon>
                                        </v-btn>
                                        <v-sheet class="transparent" height="165" >
                                            <v-card-title style="width: 90%"  class="text-truncate">
                                                {{doc.name || '(Sin nombre)'}}
                                            </v-card-title>
                                            <v-card-text class="grey lighten-3 black--text" style="border-radius: 0 0 10px 10px">
                                                <div class="caption">Subido por:</div>
                                                <v-avatar size="30">
                                                    <img :src="doc.user.avatar || getFakeAvatar(doc.user.gender)" />
                                                </v-avatar>
                                                {{doc.user.first_name}} {{doc.user.last_name || ''}}
                                                <v-divider class="my-2"></v-divider>
                                                <div class="caption text-xs-right">{{$moment(doc.created_at).fromNow()}}</div>

                                            </v-card-text>
                                        </v-sheet>
                                    </v-card>

                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-card>

      <kimsa-confirm
          ref="deleteDialog"
          title="Eliminar documento"
          content="¿Confirmas que deseas eliminar este documento?"
          :loading="loadingDelete"
          :persistent="false"
          @confirm="deleteConfirm"
          :close-on-confirm="false"
      ></kimsa-confirm>

    </v-dialog>
</template>

<script>
    import {ApiUtils} from '@/utils/ApiUtils'
    import {getFakeAvatar} from '@/utils/Common'

    import {mapState} from 'vuex'
    import KimsaConfirm from "@/components/common/KimsaConfirm";

    export default{
        props:{
            event:{
                type: Object,
              required: true
            },
            docs: {
                type: Array,
                default: () => []
            }
        },
        components: {
          KimsaConfirm,
          FilePicker: () => import('@/components/common/FilePicker')
        },
      mounted(){
          const vm = this
          vm.setDefaults()
      },
        data(){
            return{
                uploading: false,
                loadingDelete: false,
                selectedFile: null,
                dialog: false,
                localDocs: []
            }
        },
        computed:{
          ...mapState(['currentUser']),
          eventId(){
            const vm = this
            return vm.event && vm.event.id
          },
          canModify(){
            const vm = this
            return vm.event && vm.event.event_status_id === 4
          }
        },
        methods:{
            getFakeAvatar,
            openDoc(path){
              window.open(path,"_blank");
            },
            deleteFile(file){
              const vm = this
              vm.selectedFile = file
              vm.$refs.deleteDialog.show()
            },
            async deleteConfirm(){
              const vm = this
              if(!vm.selectedFile) return
              vm.loadingDelete = true
              const response = await ApiUtils.makeDelete(`appointments/${vm.eventId}/documents/${vm.selectedFile.id}`)
              vm.loadingDelete = false

              if(!response.ok){
                const json = await response.json()
                vm.toast(json.message || 'Ha ocurrido un error intentando eliminar el archivo')
                return
              }

              const index = vm.localDocs.findIndex(doc => doc.id === vm.selectedFile.id)
              if(index !== -1){
                vm.localDocs.splice(index, 1)
              }

              vm.toast('Archivo eliminado')
              vm.$refs.deleteDialog.hide()

            },
            async upload(file){

                console.log('que paho', file)
                var vm = this

                vm.uploading = true

              try{
                const response = await ApiUtils.makePost(`appointments/${vm.eventId}/document`, {
                  file: file
                })
                if(!response.ok){
                  const json = await response.json()
                  vm.$store.commit('showSnackBar', {
                    text: json.message || 'Ha ocurrido un error al cargar el archivo',
                    color: 'error'
                  })
                  return
                }

                vm.$store.commit('showSnackBar', {
                  text: 'Archivo cargado correctamente',
                  color: 'success'
                })

                const json = await response.json()
                let index = vm.localDocs.findIndex(doc => doc.id === json.result.document.id)
                if(index ===  -1){
                  vm.localDocs.push(json.result.document)
                }

              }catch(err){
                vm.toast('Ocurrió un error intentando cargar el archivo', 'error')
              }finally{
                vm.uploading = false

              }

            },
            setDefaults(){
                const vm = this
                vm.localDocs = vm.docs.slice()
            },
            show(){
                var vm = this
                vm.dialog = true
            },
            onUnsupportedFile(){
                var vm = this
                vm.$store.commit('showSnackBar', {
                    text: 'Formato no soportado',
                    color: 'error'
                })
            },
            onMaxFileSize(){
                var vm = this
                vm.$store.commit('showSnackBar', {
                    text: 'Tamaño máximo exedido',
                    color: 'error'
                })
            }
        },
        watch:{
          docs(){
            const vm = this
            vm.setDefaults()
          }
        }
    }
</script>